import { render } from "./TutorialModal.vue?vue&type=template&id=073ca1c2&scoped=true&ts=true"
import script from "./TutorialModal.vue?vue&type=script&lang=ts"
export * from "./TutorialModal.vue?vue&type=script&lang=ts"

import "./TutorialModal.vue?vue&type=style&index=0&id=073ca1c2&lang=scss"
import "./TutorialModal.vue?vue&type=style&index=1&id=073ca1c2&lang=scss&scoped=true"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073ca1c2"]])

export default __exports__